module.exports = __webpack_public_path__ + "staticcomp/img/content_3.a7f873a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/10/content_3.jpg
// module id = bRYc
// module chunks = 39